import React from "react";
import classResolver from "../../utils/helpers/tailwindClassResolver";

const Button = (props) => {
  return (
    <button
      {...props}
      className={classResolver(
        `w-full rounded-md py-1 sm:py-2 px-2 sm:px-5 text-base sm:text-lg text-white font-medium`,
        props?.className
      )}
    >
      {props.children}
    </button>
  );
};

export default Button;
